<h2 mat-dialog-title>{{ 'administration.sync-monitoring.reset-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="reset-dialog-target">
		<span class="reset-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.environment' | translate }}:</span>
		<strong>{{ environmentName }}</strong>
	</p>

	<mat-radio-group [value]="allTables" (change)="allTables = $event.value">
		<mat-radio-button [value]="true">
			{{ 'administration.sync-monitoring.reset-dialog.all-tables' | translate: { count: data.tables.length } }}
		</mat-radio-button>
		<mat-radio-button [value]="false">
			{{ 'administration.sync-monitoring.reset-dialog.selected-tables' | translate: { count: selected.size } }}
		</mat-radio-button>
	</mat-radio-group>

	<div class="audit-dialog-tables">
		@for (table of data.tables; track table.name) {
			<mat-checkbox color="primary" [checked]="selected.has(table.name)" (change)="toggleTable(table.name, $event.checked)">{{ table.name }}</mat-checkbox>
		}
	</div>

	@if (!isCompleteReset) {
		<p class="reset-dialog-warning">
			{{ 'administration.sync-monitoring.reset-dialog.warning' | translate }}
		</p>
	}

	@if (isCompleteReset) {
		<p class="reset-dialog-warning reset-dialog-warning-strong">
			{{ 'administration.sync-monitoring.reset-dialog.complete-warning' | translate }}
		</p>
	}

	@if (isCompleteReset) {
		<p class="reset-dialog-bom-warning">
			{{ 'administration.sync-monitoring.reset-dialog.bom-warning' | translate }}
		</p>
	}

	<form [formGroup]="rowVersionForm">
		<mat-form-field appearance="outline" class="reset-dialog-rowversion">
			<mat-label>
				{{ 'administration.sync-monitoring.reset-dialog.row-version' | translate }}
			</mat-label>
			<input matInput type="number" min="0" step="1" formControlName="rowVersion" [attr.aria-label]="'administration.sync-monitoring.reset-dialog.row-version' | translate" />
			<mat-hint>
				{{ 'administration.sync-monitoring.reset-dialog.row-version-hint' | translate }}
			</mat-hint>
			@if (!isRowVersionValid) {
				<mat-error>
					{{ 'administration.sync-monitoring.reset-dialog.row-version-invalid' | translate }}
				</mat-error>
			}
		</mat-form-field>

		@if (isCompleteReset) {
			<mat-checkbox formControlName="confirmComplete" color="primary" class="reset-dialog-confirm-complete">
				{{ 'administration.sync-monitoring.reset-dialog.confirm-complete' | translate }}
			</mat-checkbox>
		}
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isLoading" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="!canConfirm" (click)="onConfirm()">
		@if (isLoading) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="reset-dialog-spinner"></mat-progress-spinner>
		}
		{{ 'administration.sync-monitoring.reset-dialog.confirm' | translate }}
	</button>
</mat-dialog-actions>
